export type { EmailCredentials, TelegramWidgetUser } from "./api/auth"
export { requestTelegramLink } from "./api/auth"
export { SessionProvider, useSession } from "./model/session-context"
export { useSessionRole } from "./model/use-session-role"
export type { UserRole } from "@/shared/lib/types"
